import { useCallback, useContext } from 'react';
import { CopilotContext } from '@Sage/ssm-web5';

import {
    COPILOT_BAR_HIDDEN_STORAGE_KEY,
    mergeCopilotBarOpenWithUserPreference,
    removeCopilotPanelStorageFlag,
} from 'utils/copilotPanels';

/**
 * Copilot bar control in CRUD panel / entity modal headers: show when a scenario has
 * configured {@link copilotBarProps.chatSetup}, open or expand in sync with main header + localStorage.
 */
export default function useCopilotBarCrudHeaderToggle() {
    const { copilotBarProps, setCopilotBarProps } = useContext(CopilotContext);
    const { chatSetup, isMinimized, isOpen } = copilotBarProps;

    const showToggle = Boolean(chatSetup);
    const isToggleDisabled = Boolean(isOpen && !isMinimized);
    const preserveCustomIconColors = !isOpen || isMinimized;

    const onCopilotBarToggle = useCallback(() => {
        if (!setCopilotBarProps) return;

        if (!isOpen) {
            removeCopilotPanelStorageFlag(COPILOT_BAR_HIDDEN_STORAGE_KEY);
            setCopilotBarProps(
                mergeCopilotBarOpenWithUserPreference({
                    ...copilotBarProps,
                    isMinimized: false,
                    isOpen: true,
                }),
            );
            return;
        }

        if (isMinimized) {
            setCopilotBarProps({ isMinimized: false });
        }
    }, [copilotBarProps, isMinimized, isOpen, setCopilotBarProps]);

    return {
        isToggleDisabled,
        onCopilotBarToggle,
        preserveCustomIconColors,
        showToggle,
    };
}
